import { useMemo } from 'react';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { useGTKMDomainSubmit } from './useGTKMDomainSubmit';
import { isEligibleForACQ177ProductisedFlow } from '../utils/gtkm/isEligibleForACQ177ProductisedFlow';
import { getGtkmAnimationState } from '../store/gtkm/selector';
import { useSelector } from 'react-redux';
import { GtkmAnimationState } from '../store/gtkm/types';
import { useIsSU0004Variation } from './useIsSU0004Variation';
export const useAICompanyDomainSubmit = ({
  submit,
  isStepDataValid
}) => {
  const animationState = useSelector(state => getGtkmAnimationState(state));
  const {
    isAssignedToSpecificVariant: isAssignedToACQ177Variant
  } = useExperiment(ExperimentKeys.ACQ0177, TrackWhen.never);
  const isProductisedAndEligible = useSelector(isEligibleForACQ177ProductisedFlow);
  const isAssignedToACQ177VariantA = isProductisedAndEligible || isAssignedToACQ177Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToSU0004Variation = useIsSU0004Variation();
  const isAssignedToGTKM = isAssignedToACQ177VariantA;
  const {
    handleSubmit: handleGTKMDomainSubmit,
    handleSubmitSU0004: handleGTKMDomainSubmitSU0004
  } = useGTKMDomainSubmit();
  const onSubmit = () => {
    if (isAssignedToSU0004Variation) {
      handleGTKMDomainSubmitSU0004();
    } else if (isAssignedToGTKM) {
      handleGTKMDomainSubmit();
    } else {
      submit();
    }
  };
  const isNextButtonEnabled = useMemo(() => {
    if (!isStepDataValid) {
      return false;
    }
    if (isAssignedToSU0004Variation) {
      return true;
    }
    if (isAssignedToGTKM) {
      return animationState !== GtkmAnimationState.Started;
    }
    return undefined;
  }, [isStepDataValid, isAssignedToSU0004Variation, isAssignedToGTKM, animationState]);
  return {
    aiCompanyDomainSubmit: onSubmit,
    isAiCompanyDomainSubmitEnabled: isNextButtonEnabled
  };
};